import React, { useState, useEffect } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const DURATION_MINUTES = 15;
    const storageKey = 'merezco_cd_end';
    let endTime = localStorage.getItem(storageKey);
    if (!endTime) {
      endTime = (Date.now() + DURATION_MINUTES * 60 * 1000).toString();
      localStorage.setItem(storageKey, endTime);
    }
    const interval = setInterval(() => {
      const now = Date.now();
      let remaining = Math.max(0, parseInt(endTime!) - now);
      if (remaining === 0) {
        endTime = (Date.now() + DURATION_MINUTES * 60 * 1000).toString();
        localStorage.setItem(storageKey, endTime);
        remaining = DURATION_MINUTES * 60 * 1000;
      }
      setTimeLeft({
        hours: Math.floor(remaining / 3600000),
        minutes: Math.floor(remaining % 3600000 / 60000),
        seconds: Math.floor(remaining % 60000 / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (num: number) => String(num).padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-[#1a0533] via-[#2d1458] to-[#1a0533] border-b border-gold/30 px-5 py-2.5 flex items-center justify-center gap-4 flex-wrap" data-id="element-276" data-mp="1wp2izew97r9u">
      <span className="text-[13px] font-medium text-white tracking-wide text-center" data-id="element-277" data-mp="1mz97sf00xe64">
        ⚡ <span className="text-gold font-bold" data-id="element-278" data-mp="2anioj2idrbqe">OFERTA ESPECIAL LATAM</span> — Pack completo de $128 por solo <span className="text-gold font-bold" data-id="element-279" data-mp="2fn52je618w09">$9.99 USD</span>
      </span>
      
      <div className="flex items-center gap-1.5" data-id="element-280" data-mp="21nnbst96f8o9">
        <div className="bg-gold/15 border border-gold/30 rounded-md px-2 py-0.5 text-sm font-bold text-gold tabular-nums min-w-[32px] text-center" data-id="element-281" data-mp="21mudmgoa9rhq">
          {pad(timeLeft.hours)}
        </div>
        <span className="text-gold font-bold text-sm" data-id="element-282" data-mp="q6dw8ht650s8">:</span>
        <div className="bg-gold/15 border border-gold/30 rounded-md px-2 py-0.5 text-sm font-bold text-gold tabular-nums min-w-[32px] text-center" data-id="element-283" data-mp="u9sms2eqgzjx">
          {pad(timeLeft.minutes)}
        </div>
        <span className="text-gold font-bold text-sm" data-id="element-284" data-mp="2rwl3ng4ckvbs">:</span>
        <div className="bg-gold/15 border border-gold/30 rounded-md px-2 py-0.5 text-sm font-bold text-gold tabular-nums min-w-[32px] text-center" data-id="element-285" data-mp="2rzgygvkwf3w0">
          {pad(timeLeft.seconds)}
        </div>
      </div>

      <a href="#oferta" className="bg-gradient-to-br from-violet to-violet-dark text-white font-bold text-[13px] px-5 py-2 rounded-lg shadow-[0_4px_14px_rgba(124,58,237,0.4)] hover:shadow-[0_6px_20px_rgba(124,58,237,0.6)] hover:-translate-y-0.5 transition-all" data-id="element-286" data-mp="2e5q08jcmb6fl">
        ¡LO QUIERO AHORA!
      </a>
    </div>;
}